import React, { useEffect, useState } from "react";
import PlatformCard from "./PlatformCard";
import "./SocialProfile.scss";
import { useDispatch, useSelector } from "react-redux";
import { totalPlatformsConnected } from "../../../../actions/utils";
import { fetchTokenList } from "../../../../actions/tokensAction";
import { formatTokenLists } from "../../../../actions/utils";
import { toast } from "react-toastify";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import UseGAEventsTracker from "../../../hooks/UseGAEventsTracker";
import { stepsCompleted } from "../../../../actions/globalAction";
import CurrentStepIndicator from "../CurrentStepIndicator";
import VideoModal from "../../../UIComponents/VideoModal/VideoModal";
import { ReactComponent as Play } from "../../../../assets/svg/play-button.svg";
import Radio from "semantic-ui-react/dist/es/addons/Radio";
import Scrollbars from "react-custom-scrollbars";

const SocialProfile = ({ isMobile, history, company }) => {
    const dispatch = useDispatch();
    const platforms = useSelector((state) => state.filterSettingReducer.masterPlatforms);
    const tokenLists = useSelector((state) => state.tokensReducer.tokenList);
    // const [submitting, setSubmitting] = useState(false);
    const [nextDisabled, setNextDisabled] = useState(true);

    const [openPopup, setOpenPopup] = useState(true);
    const [tokenLength, setTokenLength] = useState(0);
    const GAEventTracker = UseGAEventsTracker("New user SignUp");

    const requiredPlatforms = ["Instagram", "X", "Facebook", "LinkedIn", "TikTok", "Google Business", "Google Play Store", "App Store", "Telegram"];

    const filteredPlatforms = platforms.filter((obj) => requiredPlatforms.includes(obj.name));

    const platformsWithOrder = filteredPlatforms.map((obj) => {
        let orderVal;
        switch (obj.name) {
            case "Facebook":
                orderVal = 1;
                break;
            case "Instagram":
                orderVal = 2;
                break;
            case "Twitter":
                orderVal = 3;
                break;
            case "TikTok":
                orderVal = 4;
                break;
            case "LinkedIn":
                orderVal = 5;
                break;
            // case "gmb":
            //     orderVal = 6;
            //     break;

            default:
                break;
        }

        return { ...obj, order: orderVal };
    });

    const orderedPlatform = platformsWithOrder.sort((a, b) => a.order - b.order);
    const formattedTokenLists = formatTokenLists(tokenLists);
    useEffect(() => {
        dispatch(fetchTokenList());
        GAEventTracker("SignUp step 3", `company-${company?.company_identifier}`);
    }, []);

    useEffect(() => {
        if (Object.keys(formattedTokenLists).length > 0) {
            dispatch(stepsCompleted("socialProfile"));
        }
        // console.log("Object.keys(formattedTokenLists).length", Object.keys(formattedTokenLists).length, Object.keys(formattedTokenLists), formattedTokenLists);
        setTokenLength(Object.keys(formattedTokenLists).length);
    }, [tokenLists]);

    const handleSocialProfilesSubmit = () => {
        // if (Object.keys(formattedTokenLists).length > 0)
        if (!nextDisabled || tokenLength > 0) history.push("/profile-setup/create-query");
        else toast.error("Please add atleast 1 profile to continue ");
    };
    const videoData = {
        url: `https://www.youtube.com/embed/nF8J3j0PitY`,
        title: "Add your social Profile",
        platformName: "Social Profile",
    };

    return (
        <>
            <div className="social__profile__container">
                <Scrollbars autoHide autoHideDuration={300}>
                    <div className="main__container">
                        <h1 className="heading">Add your social profiles</h1>

                        <p className="description">
                            Please select a platform you want to sync with Radarr. This will help us connect and fetch data for your connected profiles.
                        </p>

                        <div className="help__container">
                            <p className="help__text">Help me to add a profile (</p>
                            <span className="pointer__container" onClick={() => setOpenPopup(true)}>
                                <span className="light__text"> Watch help video </span>
                                <Play className="watch__icon" />
                            </span>
                            <span className="help__text">)</span>
                        </div>

                        <div className="validate__social__profile">
                            {
                                <p className="bg__blue">
                                    {tokenLength > 0
                                        ? `${totalPlatformsConnected(formattedTokenLists)} profile added, you can continue to use platform`
                                        : "You must add atleast 1 profile to continue"}
                                </p>
                            }
                        </div>
                        {isMobile ? (
                            <div className="chekbox__container">
                                <p>Skip this step</p>
                                <Radio toggle label="" size="tiny" checked={!nextDisabled} onClick={() => setNextDisabled((prev) => !prev)} />
                            </div>
                        ) : null}
                        <div className="platform__container">
                            {orderedPlatform.map((eachPlatform, index) => (
                                <>
                                    <PlatformCard key={index} platformDetails={eachPlatform} tokenList={formattedTokenLists} />
                                </>
                            ))}
                        </div>
                        {!isMobile ? (
                            <div className="chekbox__container">
                                <p>Skip this step</p>
                                <Radio toggle label="" size="tiny" checked={!nextDisabled} onClick={() => setNextDisabled((prev) => !prev)} />
                            </div>
                        ) : null}
                    </div>
                </Scrollbars>
            </div>

            <div className="porfile__setup__footer">
                <button
                    className={`button back__button  ${isMobile && "mobile__version__button"} `}
                    onClick={() => history.push("/profile-setup/company-details")}>
                    Previous
                </button>
                {isMobile ? <div>Step 3 of 4</div> : <CurrentStepIndicator StepCount={3} />}

                <Popup
                    content={"Please add your social profile"}
                    inverted
                    size="mini"
                    disabled={tokenLength > 0}
                    position="top center"
                    style={{ zIndex: "99999" }}
                    trigger={
                        <button
                            className={`button 
                         ${nextDisabled && tokenLength < 1 && "disabled__mode"}
                             ${isMobile && "mobile__version__button"}`}
                            onClick={handleSocialProfilesSubmit}
                            // disabled={submitting}
                        >
                            <span> {"Next"}</span>
                        </button>
                    }
                />
                {openPopup ? <VideoModal open={openPopup} hideModal={() => setOpenPopup(false)} videoData={videoData} crossOrigin="" /> : null}
            </div>
        </>
    );
};

export default SocialProfile;
